import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ILocationList } from '../../../Pages/Location/ILocation';
import { PayloadAction } from '@reduxjs/toolkit';

export const GetLocationSlicer = createSlice({
  name: 'GetOneLocation',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ILocationList>,
  reducers: {
    getOneLocation: (state, _action: PayloadAction<string | number>) => {
      state.isLoading = true;
    },
    successGetOneLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetOneLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getOneLocation, successGetOneLocation, failureGetOneLocation } =
  GetLocationSlicer.actions;

export default GetLocationSlicer.reducer;
